import React from 'react';

function BasketballGame({ score, updateScore, onBack }) {
  return (
    <div className="basketball-game" style={{ textAlign: 'center', marginTop: 40 }}>
      <h2>Basketball Game</h2>
      <div style={{
        background: 'linear-gradient(180deg, #ffb74d 90%, #fff 100%)',
        border: '4px solid #fff',
        borderRadius: 18,
        width: 400,
        height: 220,
        margin: '40px auto',
        position: 'relative',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        {/* Court Lines */}
        <div style={{position: 'absolute', top: '80%', left: '45%', width: 40, height: 4, background: '#fff', borderRadius: 4}} />
        <div style={{position: 'absolute', top: '15%', left: '50%', width: 60, height: 4, background: '#fff', borderRadius: 4, transform: 'translateX(-50%)'}} />
        {/* Hoop */}
        <div style={{position: 'absolute', top: 18, left: '50%', width: 40, height: 10, border: '2px solid #c62828', borderRadius: '0 0 20px 20px', borderTop: 'none', background: '#fff', transform: 'translateX(-50%)'}} />
        {/* Ball */}
        <span role="img" aria-label="basketball" style={{position: 'absolute', top: 120, left: 190, fontSize: 36}}>🏀</span>
      </div>
      <div style={{margin:'20px 0'}}>
        <span style={{fontWeight:'bold'}}>{score.teamA} : </span>
        <button onClick={() => updateScore('basketball', score.scoreA-1 >= 0 ? score.scoreA-1 : 0, score.scoreB)}>-</button>
        <span style={{margin:'0 10px'}}>{score.scoreA}</span>
        <button onClick={() => updateScore('basketball', score.scoreA+1, score.scoreB)}>+</button>
        <span style={{margin:'0 20px'}}>|</span>
        <span style={{fontWeight:'bold'}}>{score.teamB} : </span>
        <button onClick={() => updateScore('basketball', score.scoreA, score.scoreB-1 >= 0 ? score.scoreB-1 : 0)}>-</button>
        <span style={{margin:'0 10px'}}>{score.scoreB}</span>
        <button onClick={() => updateScore('basketball', score.scoreA, score.scoreB+1)}>+</button>
      </div>
      <button onClick={onBack}>Back</button>
    </div>
  );
}

export default BasketballGame;
